/* eslint-disable no-unused-vars */
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { Edit } from "@material-ui/icons/";
import DesktopWindows from "@material-ui/icons/DesktopWindows";
// core components
import Navbar from "components/Navbars/Navbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";

import bgImage from "assets/img/sidebar-2.jpg";
import logo from "assets/img/logo2.png";

import Edit1 from "views/Signature/Edit.js";
import Medical from "views/Signature/Medical2568.js";
import SignatureD from "views/Signature/Signature";
import PdfSign from "views/Report/PdfSign";
import Administrative from "views/Signature/Administrative2568";
import Nurse from "views/Signature/Nurse2568.js";
import HealthDev from "views/Signature/HealthDev2568.js";
import Year from "views/Signature/Year.js";
import axios from "axios";
import React, { useState, useEffect} from "react";
import Goto from "views/Signature/Goto";
let ps;


const useStyles = makeStyles(styles);

export default function Signature({ ...rest }) {
  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  const [image, setImage] = React.useState(bgImage);
  const [color, setColor] = React.useState("blue");
  const [fixedClasses, setFixedClasses] = React.useState("dropdown show");
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [listTitle, setListTitle] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [routes2, setRoutes2] = useState([]);

  //   useEffect(() => {
  //   axios.get("/api/v1/signature/title")
  //   .then( 
  //     result => {
  //       listTitle.push(result.data.data);
  //       result.data.data.forEach(e => {
  //         listTitle.push(e);
  //       });

  //       setRoutes2(test);
  //       console.log(routes2);
  //     },
  //       error => { 
  //         console.log(error); 
  //       }
  //   );  
  // }, [])

  //const shouldShowRoutes = selectedYear !== "" && selectedYear !== null ? true : false;

  const routes = [
    // {
    //   name: "เลือกปี",
    //   icon: DesktopWindows,
    //   component: Year,
    //   layout: "/signature",
    //   path: "/year"
    // },
    {
      name: "เลือกปี",
      icon: DesktopWindows,
      component: (props) => <Year {...props} onYearChange={handleYearChange} />,
      layout: "/signature",
      path: "/year",
    },
    {
      name: "แก้ไขรายละเอียด",
      icon: Edit,
      component: Edit1,
      layout: "/signature",
      path: "/edit1"
    },
    {
      name: "การลงนามคำรับรอง ฯ หัวหน้ากลุ่มงาน",
      icon: DesktopWindows,
      layout: "/subsignature",
      path: ""
    },
  ]

  useEffect(() => {
    axios
      .get("/api/v1/signature/title")
      .then((result) => {
        console.log("Raw data from API:", result.data.data); 
        const data = result.data.data;
        const filteredData = data.filter((item) => item.isDeputy === true);
        console.log("Filtered Data (IsDeputy = 1):", filteredData);
        
        // const componentMap = {
        //   1: (props) => <Medical {...props} customData={selectedYear} />,
        //   2: (props) => <Administrative {...props} customData={selectedYear} />,
        //   3: (props) => <Nurse {...props} customData={selectedYear} />,
        //   4: (props) => <HealthDev {...props} customData={selectedYear} />,
        // };
        
        const routes = filteredData.map((item) => ({
          name: item.titleName,
          icon: Edit,
          component: (props) => <SignatureD {...props} titleId={item.titleId} />, 
          //component: componentMap[item.titleId],
          layout: "/signature",
          path: `/title/${item.titleId}`, 
        }));
  
        setListTitle(filteredData);
        setRoutes2(routes); 
      })
      .catch((error) => {
        console.error("Error fetching titles:", error);
      });
  }, []);
  
  
  const filteredRoutes = React.useMemo(() => {
    //if (!selectedYear || routes2.length === 0) {
      // แสดงเฉพาะเมนูสำหรับเลือกปี หากยังไม่ได้เลือกปีหรือยังโหลด routes2 ไม่เสร็จ
      //return routes;
    //}
    // รวม routes พื้นฐานกับ routes2 เฉพาะเมื่อเลือกปีแล้ว
    return routes.concat(routes2);
  }, [selectedYear, routes2]);

  

  //       const test = [
  //         {
  //           name: "รองผู้อำนวยการด้านการแพทย์",
  //           icon: Edit,
  //           component: (props) => <Medical {...props} customData={selectedYear} />, 
  //           layout: "/signature",
  //           path: "/medical"
  //         },
  //         {
  //           name: "รองผู้อำนวยการด้านอำนวยการ",
  //           icon: Edit,
  //           component: (props) => <Administrative {...props} customData={selectedYear} />, 
  //           layout: "/signature",
  //           path: "/administrative"
  //         },
  //         {
  //           name: "รองผู้อำนวยการด้านการพยาบาล",
  //           icon: Edit,
  //           component: (props) => <Nurse {...props} customData={selectedYear} />, 
  //           layout: "/signature",
  //           path: "/nurse"
  //         },
  //         {
  //           name: "รองผู้อำนวยการด้านพัฒนาระบบสุขภาพ",
  //           icon: Edit,
  //           component: (props) => <HealthDev {...props} customData={selectedYear} />, 
  //           layout: "/signature",
  //           path: "/health"
  //         },
  //         {
  //           name: "การลงนามคำรับรอง ฯ หัวหน้ากลุ่มงาน",
  //           icon: DesktopWindows,
  //           layout: "/subsignature",
  //           path: ""
  //         }
  //         // ,
  //         // {
  //         //   name: "แก้ไขรายละเอียด",
  //         //   icon: Edit,
  //         //   component: Edit1,
  //         //   layout: "/signature",
  //         //   path: "/edit1"
  //         // }
  //       ];
 
  // const filteredRoutes = React.useMemo(() => {
  //   return shouldShowRoutes ? routes.concat(routes2) : routes;
  // }, [shouldShowRoutes]);

  // const filteredRoutes = React.useMemo(() => {
  //   return shouldShowRoutes ? routes2 : routes2;
  // }, [shouldShowRoutes]);

  const switchRoutes = (
    <Switch>
      {filteredRoutes.map((prop, key) => {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      })}
  
      <Route path="/signature/pdfsign" component={PdfSign} />
      <Route path="/signature/id/:TitleId" component={Goto} />
      <Redirect from="/signature" to="/signature/year" />
    </Switch>
  );

  useEffect(() => {
  }, [selectedYear]);
  

  const handleYearChange = (year) => {
    if (year === selectedYear) return; 
    setSelectedYear(year);
  };
  const handleImageClick = image => {
    setImage(image);
  };
  const handleColorClick = color => {
    setColor(color);
  };
  const handleFixedClick = () => {
    if (fixedClasses === "dropdown") {
      setFixedClasses("dropdown show");
    } else {
      setFixedClasses("dropdown");
    }
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };

  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);
  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={filteredRoutes}
        logoText={"การลงนามคำรับรองฯ"}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar
          routes={filteredRoutes}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
          </div>
        ) : (
          <div className={classes.map}>{switchRoutes}</div>
        )}
        {getRoute() ? <Footer /> : null}
        {/* <FixedPlugin
          handleImageClick={handleImageClick}
          handleColorClick={handleColorClick}
          bgColor={color}
          bgImage={image}
          handleFixedClick={handleFixedClick}
          fixedClasses={fixedClasses}
        /> */}

      </div>
    </div>
  );
}
